export default __webpack_public_path__ + "static/media/feature.44869d5d.jpg";